import * as React from "react"

export default function HeartOutlineIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.75 2.5c2.531 0 4.583 2.083 4.583 5 0 5.833-6.25 9.167-8.334 10.417-2.083-1.25-8.333-4.584-8.333-10.417 0-2.917 2.083-5 4.583-5 1.55 0 2.917.833 3.75 1.667.834-.834 2.2-1.667 3.75-1.667zm-2.972 13.003a22.449 22.449 0 002.016-1.417c2.484-1.975 3.872-4.133 3.872-6.586 0-1.967-1.28-3.333-2.917-3.333-.896 0-1.866.475-2.571 1.178L9.999 6.523 8.821 5.345c-.705-.703-1.675-1.178-2.572-1.178-1.616 0-2.916 1.38-2.916 3.333 0 2.453 1.388 4.61 3.87 6.586.621.493 1.284.954 2.018 1.416.25.158.496.309.778.477.283-.168.53-.319.779-.476z"
        fill={props.fill}
      />
    </svg>
  )
}
